// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_pending.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { TaskSearchRequest } from "../../task/v1/search";
import { Struct } from "../../../../google/protobuf/struct";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * Snapshot of display data at queue time
 * Note: Access review data model enforces 1 ticket = 1 selection = 1 entitlement
 *
 * @generated from protobuf message c1.api.accessreview.v1.PendingActionSnapshot
 */
export interface PendingActionSnapshot {
    /**
     * @generated from protobuf field: string user_display_name = 1;
     */
    userDisplayName: string;
    /**
     * @generated from protobuf field: string app_display_name = 2;
     */
    appDisplayName: string;
    /**
     * @generated from protobuf field: string entitlement_display_name = 3;
     */
    entitlementDisplayName: string; // Singular - always exactly one entitlement
    /**
     * @generated from protobuf field: string subject_display_name = 4;
     */
    subjectDisplayName: string;
    /**
     * @generated from protobuf field: string subject_identifier = 5;
     */
    subjectIdentifier: string;
}
/**
 * Display view of a pending action
 * Lightweight - no conflict detection (use ValidatePendingActions for that)
 *
 * @generated from protobuf message c1.api.accessreview.v1.PendingActionView
 */
export interface PendingActionView {
    /**
     * @generated from protobuf field: string certify_task_id = 1;
     */
    certifyTaskId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewPendingDecision decision = 2;
     */
    decision: ReviewPendingDecision;
    /**
     * @generated from protobuf field: string comment = 3;
     */
    comment: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp queued_at = 4;
     */
    queuedAt?: Timestamp;
    /**
     * Snapshot of what reviewer saw when queuing this action
     *
     * @generated from protobuf field: c1.api.accessreview.v1.PendingActionSnapshot snapshot = 5;
     */
    snapshot?: PendingActionSnapshot;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.PendingActionConflict
 */
export interface PendingActionConflict {
    /**
     * @generated from protobuf field: string certify_task_id = 1;
     */
    certifyTaskId: string;
    /**
     * @generated from protobuf field: string reason = 2;
     */
    reason: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewPendingDecision queued_decision = 3;
     */
    queuedDecision: ReviewPendingDecision;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.PendingSummary
 */
export interface PendingSummary {
    /**
     * @generated from protobuf field: int32 total_count = 1;
     */
    totalCount: number;
    /**
     * @generated from protobuf field: int32 approve_count = 2;
     */
    approveCount: number;
    /**
     * @generated from protobuf field: int32 deny_count = 3;
     */
    denyCount: number;
    /**
     * @generated from protobuf field: int32 conflict_count = 4;
     */
    conflictCount: number;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.PendingActionConflict conflicts = 5;
     */
    conflicts: PendingActionConflict[];
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SubmissionView active_submission = 6;
     */
    activeSubmission?: SubmissionView;
}
/**
 * Reference for a reviewer's pending summary.
 *
 * @generated from protobuf message c1.api.accessreview.v1.PendingSummaryRef
 */
export interface PendingSummaryRef {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 2;
     */
    reviewerUserId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.TimestampTokenView
 */
export interface TimestampTokenView {
    /**
     * @generated from protobuf field: string url = 1;
     */
    url: string;
    /**
     * @generated from protobuf field: string policy_oid = 2;
     */
    policyOid: string;
    /**
     * @generated from protobuf field: string serial_number = 3;
     */
    serialNumber: string; // Token serial (from TST), not cert serial
    /**
     * @generated from protobuf field: google.protobuf.Timestamp generated_at = 4;
     */
    generatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string tsa_fingerprint_sha256 = 5;
     */
    tsaFingerprintSha256: string;
    /**
     * @generated from protobuf field: string hashed_message = 6;
     */
    hashedMessage: string;
    /**
     * @generated from protobuf field: bytes tsr_der = 7;
     */
    tsrDer: Uint8Array;
    /**
     * TSA certificate display fields (user-friendly, parsed)
     *
     * @generated from protobuf field: string tsa_cert_primary_name = 8;
     */
    tsaCertPrimaryName: string; // Subject CN/O (first present: CN, O, organizationIdentifier, serialNumber, OU)
    /**
     * @generated from protobuf field: string tsa_cert_issuer_short = 9;
     */
    tsaCertIssuerShort: string; // Issuer CN/O (first present: CN, O)
    /**
     * @generated from protobuf field: string tsa_cert_serial8 = 10;
     */
    tsaCertSerial8: string; // Last 8 hex chars of cert serial
    /**
     * @generated from protobuf field: string tsa_cert_not_after_date = 11;
     */
    tsaCertNotAfterDate: string; // YYYY-MM-DD (cert expiry)
    /**
     * @generated from protobuf field: string tsa_cert_ski8 = 12;
     */
    tsaCertSki8: string; // First 8 hex chars of Subject Key Identifier
    /**
     * Full certificate DNs (for advanced users/debugging)
     *
     * @generated from protobuf field: string tsa_cert_subject_dn = 13;
     */
    tsaCertSubjectDn: string; // Full subject DN string
    /**
     * @generated from protobuf field: string tsa_cert_issuer_dn = 14;
     */
    tsaCertIssuerDn: string; // Full issuer DN string
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SignatureView
 */
export interface SignatureView {
    /**
     * @generated from protobuf field: string submission_id = 1;
     */
    submissionId: string; // Signature ID = Submission ID (1:1 relationship)
    /**
     * @generated from protobuf field: string access_review_id = 2;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 3;
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: string step_up_transaction_id = 4;
     */
    stepUpTransactionId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp mfa_verified_at = 5;
     */
    mfaVerifiedAt?: Timestamp;
    /**
     * @generated from protobuf field: string rsr_sha256 = 6;
     */
    rsrSha256: string;
    /**
     * @generated from protobuf field: string rsr_download_url = 7;
     */
    rsrDownloadUrl: string; // Capability URL: /file/{encrypted_token}, expires in 5 minutes
    /**
     * @generated from protobuf field: string meaning_of_signature = 8;
     */
    meaningOfSignature: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct auth_context_claims = 9;
     */
    authContextClaims?: Struct;
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.TimestampTokenView timestamp_tokens = 10;
     */
    timestampTokens: TimestampTokenView[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 11;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: int32 total_count = 12;
     */
    totalCount: number;
    /**
     * @generated from protobuf field: int32 approve_count = 13;
     */
    approveCount: number;
    /**
     * @generated from protobuf field: int32 deny_count = 14;
     */
    denyCount: number;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SubmissionView
 */
export interface SubmissionView {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string access_review_id = 2;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 3;
     */
    reviewerUserId: string;
    /**
     * @generated from protobuf field: int32 approve_count = 4;
     */
    approveCount: number;
    /**
     * @generated from protobuf field: int32 deny_count = 5;
     */
    denyCount: number;
    /**
     * @generated from protobuf field: int32 total_count = 6;
     */
    totalCount: number;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewSubmissionState state = 7;
     */
    state: ReviewSubmissionState;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 8;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 9;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 10;
     */
    completedAt?: Timestamp;
    /**
     * @generated from protobuf field: int32 success_count = 11;
     */
    successCount: number;
    /**
     * @generated from protobuf field: int32 error_count = 12;
     */
    errorCount: number;
    /**
     * @generated from protobuf field: int32 superseded_count = 13;
     */
    supersededCount: number;
    /**
     * @generated from protobuf field: string error_message = 14;
     */
    errorMessage: string;
    /**
     * Signature (if campaign requires signatures) - keyed by submission.id
     *
     * @generated from protobuf field: c1.api.accessreview.v1.SignatureView signature = 15;
     */
    signature?: SignatureView;
    /**
     * number of actions that were successfully processed
     *
     * @generated from protobuf field: int32 processed_approved_count = 16;
     */
    processedApprovedCount: number;
    /**
     * @generated from protobuf field: int32 processed_denied_count = 17;
     */
    processedDeniedCount: number;
}
/**
 * Single pending action item for upsert
 *
 * @generated from protobuf message c1.api.accessreview.v1.PendingActionItem
 */
export interface PendingActionItem {
    /**
     * @generated from protobuf field: string certify_task_id = 1;
     */
    certifyTaskId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewPendingDecision decision = 2;
     */
    decision: ReviewPendingDecision;
    /**
     * @generated from protobuf field: string comment = 3;
     */
    comment: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.UpsertPendingActionRequest
 */
export interface UpsertPendingActionRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * Batch of actions to upsert (1-512 items)
     * Server fetches tasks to derive access_review_selection_id and build snapshots
     *
     * @generated from protobuf field: repeated c1.api.accessreview.v1.PendingActionItem actions = 2;
     */
    actions: PendingActionItem[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.UpsertPendingActionResponse
 */
export interface UpsertPendingActionResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.PendingSummary summary = 1;
     */
    summary?: PendingSummary;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.RemovePendingActionRequest
 */
export interface RemovePendingActionRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * Task ID (API terminology - maps to certify_ticket_id internally)
     *
     * @generated from protobuf field: string certify_task_id = 2;
     */
    certifyTaskId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.RemovePendingActionResponse
 */
export interface RemovePendingActionResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.PendingSummary summary = 1;
     */
    summary?: PendingSummary;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ListPendingActionsRequest
 */
export interface ListPendingActionsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewPendingDecision decision_filter = 4;
     */
    decisionFilter: ReviewPendingDecision;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ListPendingActionsResponse
 */
export interface ListPendingActionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.PendingActionView list = 1;
     */
    list: PendingActionView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetPendingSummaryRequest
 */
export interface GetPendingSummaryRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetPendingSummaryResponse
 */
export interface GetPendingSummaryResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.PendingSummary summary = 1;
     */
    summary?: PendingSummary;
    /**
     * @generated from protobuf field: string access_review_id = 2;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string reviewer_user_id = 3;
     */
    reviewerUserId: string;
}
// ----------------------------------------------------------------------------
// GetPendingActionsByTaskIDs
// ----------------------------------------------------------------------------

/**
 * @generated from protobuf message c1.api.accessreview.v1.GetPendingActionsByTaskIDsRequest
 */
export interface GetPendingActionsByTaskIDsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * Task IDs to look up (1-100 items)
     *
     * @generated from protobuf field: repeated string certify_task_ids = 2;
     */
    certifyTaskIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetPendingActionsByTaskIDsResponse
 */
export interface GetPendingActionsByTaskIDsResponse {
    /**
     * @generated from protobuf field: map<string, c1.api.accessreview.v1.PendingActionState> states = 1;
     */
    states: {
        [key: string]: PendingActionState;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.PendingActionState
 */
export interface PendingActionState {
    /**
     * @generated from protobuf oneof: state
     */
    state: {
        oneofKind: "unlocked";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.PendingActionView unlocked = 1;
         */
        unlocked: PendingActionView;
    } | {
        oneofKind: "locked";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.LockedActionInfo locked = 2;
         */
        locked: LockedActionInfo;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.LockedActionInfo
 */
export interface LockedActionInfo {
    /**
     * @generated from protobuf field: string submission_id = 1;
     */
    submissionId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewPendingDecision decision = 2;
     */
    decision: ReviewPendingDecision;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp queued_at = 3;
     */
    queuedAt?: Timestamp;
}
// ----------------------------------------------------------------------------
// ValidatePendingActions
// ----------------------------------------------------------------------------

/**
 * @generated from protobuf message c1.api.accessreview.v1.ValidatePendingActionsRequest
 */
export interface ValidatePendingActionsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * Optional: validate specific tasks (empty = validate all pending actions)
     *
     * @generated from protobuf field: repeated string certify_task_ids = 2;
     */
    certifyTaskIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ValidatePendingActionsResponse
 */
export interface ValidatePendingActionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.PendingActionConflict conflicts = 1;
     */
    conflicts: PendingActionConflict[];
    /**
     * @generated from protobuf field: int32 valid_count = 2;
     */
    validCount: number;
    /**
     * @generated from protobuf field: int32 conflict_count = 3;
     */
    conflictCount: number;
}
// ----------------------------------------------------------------------------
// DiscardAllPending
// ----------------------------------------------------------------------------

/**
 * @generated from protobuf message c1.api.accessreview.v1.DiscardAllPendingRequest
 */
export interface DiscardAllPendingRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.DiscardAllPendingResponse
 */
export interface DiscardAllPendingResponse {
    /**
     * @generated from protobuf field: int32 discarded_count = 1;
     */
    discardedCount: number;
}
// ----------------------------------------------------------------------------
// DiscardPendingBySearch
// ----------------------------------------------------------------------------

/**
 * @generated from protobuf message c1.api.accessreview.v1.DiscardPendingBySearchRequest
 */
export interface DiscardPendingBySearchRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: c1.api.task.v1.TaskSearchRequest search_request = 2;
     */
    searchRequest?: TaskSearchRequest;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.DiscardPendingBySearchResponse
 */
export interface DiscardPendingBySearchResponse {
    /**
     * @generated from protobuf field: int32 discarded_count = 1;
     */
    discardedCount: number;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.PendingSummary summary = 2;
     */
    summary?: PendingSummary;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SubmitReviewRequest
 */
export interface SubmitReviewRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string step_up_transaction_id = 2;
     */
    stepUpTransactionId: string;
    /**
     * @generated from protobuf field: bool acknowledge_conflicts = 3;
     */
    acknowledgeConflicts: boolean;
    /**
     * @generated from protobuf field: string certify_task_id = 4;
     */
    certifyTaskId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SubmitReviewResponse
 */
export interface SubmitReviewResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SubmissionAccepted submission_accepted = 1;
     */
    submissionAccepted?: SubmissionAccepted;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SubmissionAccepted
 */
export interface SubmissionAccepted {
    /**
     * @generated from protobuf field: string submission_id = 1;
     */
    submissionId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SubmissionView submission = 2;
     */
    submission?: SubmissionView;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetSubmissionStatusRequest
 */
export interface GetSubmissionStatusRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string submission_id = 2;
     */
    submissionId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetSubmissionStatusResponse
 */
export interface GetSubmissionStatusResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SubmissionView submission = 1;
     */
    submission?: SubmissionView;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ListSubmissionsRequest
 */
export interface ListSubmissionsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.ReviewSubmissionState state_filter = 4;
     */
    stateFilter: ReviewSubmissionState;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.ListSubmissionsResponse
 */
export interface ListSubmissionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.SubmissionView list = 1;
     */
    list: SubmissionView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.InitiateStepUpForSubmitRequest
 */
export interface InitiateStepUpForSubmitRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * Optional return path to redirect to after step-up auth (e.g., "/admin/campaigns" for admin view)
     *
     * @generated from protobuf field: string return_path = 2;
     */
    returnPath: string;
    /**
     * @generated from protobuf field: string certify_task_id = 3;
     */
    certifyTaskId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.InitiateStepUpForSubmitResponse
 */
export interface InitiateStepUpForSubmitResponse {
    /**
     * @generated from protobuf field: string submission_id = 1;
     */
    submissionId: string;
    /**
     * @generated from protobuf field: string authorization_url = 3;
     */
    authorizationUrl: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetLatestSubmissionRequest
 */
export interface GetLatestSubmissionRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.GetLatestSubmissionResponse
 */
export interface GetLatestSubmissionResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SignatureView signature = 1;
     */
    signature?: SignatureView;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SubmissionView submission = 2;
     */
    submission?: SubmissionView;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchSubmissionsRequest
 */
export interface SearchSubmissionsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchSubmissionsResponse
 */
export interface SearchSubmissionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.SubmissionView list = 1;
     */
    list: SubmissionView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchSubmissionsByAdminRequest
 */
export interface SearchSubmissionsByAdminRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SearchSubmissionsByAdminResponse
 */
export interface SearchSubmissionsByAdminResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessreview.v1.SubmissionView list = 1;
     */
    list: SubmissionView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * Request to export all submissions for a campaign to CSV
 *
 * @generated from protobuf message c1.api.accessreview.v1.SubmissionsDownloadRequest
 */
export interface SubmissionsDownloadRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ReviewPendingDecision
 */
export enum ReviewPendingDecision {
    /**
     * @generated from protobuf enum value: REVIEW_PENDING_DECISION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REVIEW_PENDING_DECISION_APPROVE = 1;
     */
    APPROVE = 1,
    /**
     * @generated from protobuf enum value: REVIEW_PENDING_DECISION_DENY = 2;
     */
    DENY = 2
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.ReviewSubmissionState
 */
export enum ReviewSubmissionState {
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_WAITING_FOR_SIGNATURE = 1;
     */
    WAITING_FOR_SIGNATURE = 1,
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_PENDING = 2;
     */
    PENDING = 2,
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_PROCESSING = 3;
     */
    PROCESSING = 3,
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_COMPLETED = 4;
     */
    COMPLETED = 4,
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_PARTIAL = 5;
     */
    PARTIAL = 5,
    /**
     * @generated from protobuf enum value: REVIEW_SUBMISSION_STATE_ERROR = 6;
     */
    ERROR = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class PendingActionSnapshot$Type extends MessageType<PendingActionSnapshot> {
    constructor() {
        super("c1.api.accessreview.v1.PendingActionSnapshot", [
            { no: 1, name: "user_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "subject_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "subject_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingActionSnapshot
 */
export const PendingActionSnapshot = new PendingActionSnapshot$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingActionView$Type extends MessageType<PendingActionView> {
    constructor() {
        super("c1.api.accessreview.v1.PendingActionView", [
            { no: 1, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "decision", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewPendingDecision", ReviewPendingDecision, "REVIEW_PENDING_DECISION_"] },
            { no: 3, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "queued_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "snapshot", kind: "message", T: () => PendingActionSnapshot }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingActionView
 */
export const PendingActionView = new PendingActionView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingActionConflict$Type extends MessageType<PendingActionConflict> {
    constructor() {
        super("c1.api.accessreview.v1.PendingActionConflict", [
            { no: 1, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "queued_decision", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewPendingDecision", ReviewPendingDecision, "REVIEW_PENDING_DECISION_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingActionConflict
 */
export const PendingActionConflict = new PendingActionConflict$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingSummary$Type extends MessageType<PendingSummary> {
    constructor() {
        super("c1.api.accessreview.v1.PendingSummary", [
            { no: 1, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "approve_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "deny_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "conflict_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "conflicts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PendingActionConflict },
            { no: 6, name: "active_submission", kind: "message", T: () => SubmissionView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingSummary
 */
export const PendingSummary = new PendingSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingSummaryRef$Type extends MessageType<PendingSummaryRef> {
    constructor() {
        super("c1.api.accessreview.v1.PendingSummaryRef", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingSummaryRef
 */
export const PendingSummaryRef = new PendingSummaryRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimestampTokenView$Type extends MessageType<TimestampTokenView> {
    constructor() {
        super("c1.api.accessreview.v1.TimestampTokenView", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "policy_oid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "serial_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "generated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "tsa_fingerprint_sha256", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "hashed_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "tsr_der", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 8, name: "tsa_cert_primary_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "tsa_cert_issuer_short", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "tsa_cert_serial8", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "tsa_cert_not_after_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "tsa_cert_ski8", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "tsa_cert_subject_dn", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "tsa_cert_issuer_dn", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.TimestampTokenView
 */
export const TimestampTokenView = new TimestampTokenView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SignatureView$Type extends MessageType<SignatureView> {
    constructor() {
        super("c1.api.accessreview.v1.SignatureView", [
            { no: 1, name: "submission_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "step_up_transaction_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "mfa_verified_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "rsr_sha256", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "rsr_download_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "meaning_of_signature", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "auth_context_claims", kind: "message", T: () => Struct },
            { no: 10, name: "timestamp_tokens", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TimestampTokenView },
            { no: 11, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "approve_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "deny_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SignatureView
 */
export const SignatureView = new SignatureView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmissionView$Type extends MessageType<SubmissionView> {
    constructor() {
        super("c1.api.accessreview.v1.SubmissionView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "approve_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "deny_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "state", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewSubmissionState", ReviewSubmissionState, "REVIEW_SUBMISSION_STATE_"] },
            { no: 8, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "completed_at", kind: "message", T: () => Timestamp },
            { no: 11, name: "success_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "error_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "superseded_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "signature", kind: "message", T: () => SignatureView },
            { no: 16, name: "processed_approved_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "processed_denied_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SubmissionView
 */
export const SubmissionView = new SubmissionView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingActionItem$Type extends MessageType<PendingActionItem> {
    constructor() {
        super("c1.api.accessreview.v1.PendingActionItem", [
            { no: 1, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "decision", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewPendingDecision", ReviewPendingDecision, "REVIEW_PENDING_DECISION_"], options: { "validate.rules": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "comment", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingActionItem
 */
export const PendingActionItem = new PendingActionItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpsertPendingActionRequest$Type extends MessageType<UpsertPendingActionRequest> {
    constructor() {
        super("c1.api.accessreview.v1.UpsertPendingActionRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "actions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PendingActionItem, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "512" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.UpsertPendingActionRequest
 */
export const UpsertPendingActionRequest = new UpsertPendingActionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpsertPendingActionResponse$Type extends MessageType<UpsertPendingActionResponse> {
    constructor() {
        super("c1.api.accessreview.v1.UpsertPendingActionResponse", [
            { no: 1, name: "summary", kind: "message", T: () => PendingSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.UpsertPendingActionResponse
 */
export const UpsertPendingActionResponse = new UpsertPendingActionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemovePendingActionRequest$Type extends MessageType<RemovePendingActionRequest> {
    constructor() {
        super("c1.api.accessreview.v1.RemovePendingActionRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.RemovePendingActionRequest
 */
export const RemovePendingActionRequest = new RemovePendingActionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemovePendingActionResponse$Type extends MessageType<RemovePendingActionResponse> {
    constructor() {
        super("c1.api.accessreview.v1.RemovePendingActionResponse", [
            { no: 1, name: "summary", kind: "message", T: () => PendingSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.RemovePendingActionResponse
 */
export const RemovePendingActionResponse = new RemovePendingActionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPendingActionsRequest$Type extends MessageType<ListPendingActionsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.ListPendingActionsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 250, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "decision_filter", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewPendingDecision", ReviewPendingDecision, "REVIEW_PENDING_DECISION_"], options: { "validate.rules": { enum: { definedOnly: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ListPendingActionsRequest
 */
export const ListPendingActionsRequest = new ListPendingActionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListPendingActionsResponse$Type extends MessageType<ListPendingActionsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.ListPendingActionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PendingActionView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ListPendingActionsResponse
 */
export const ListPendingActionsResponse = new ListPendingActionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPendingSummaryRequest$Type extends MessageType<GetPendingSummaryRequest> {
    constructor() {
        super("c1.api.accessreview.v1.GetPendingSummaryRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetPendingSummaryRequest
 */
export const GetPendingSummaryRequest = new GetPendingSummaryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPendingSummaryResponse$Type extends MessageType<GetPendingSummaryResponse> {
    constructor() {
        super("c1.api.accessreview.v1.GetPendingSummaryResponse", [
            { no: 1, name: "summary", kind: "message", T: () => PendingSummary },
            { no: 2, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "reviewer_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetPendingSummaryResponse
 */
export const GetPendingSummaryResponse = new GetPendingSummaryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPendingActionsByTaskIDsRequest$Type extends MessageType<GetPendingActionsByTaskIDsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.GetPendingActionsByTaskIDsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "certify_task_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetPendingActionsByTaskIDsRequest
 */
export const GetPendingActionsByTaskIDsRequest = new GetPendingActionsByTaskIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPendingActionsByTaskIDsResponse$Type extends MessageType<GetPendingActionsByTaskIDsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.GetPendingActionsByTaskIDsResponse", [
            { no: 1, name: "states", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => PendingActionState } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetPendingActionsByTaskIDsResponse
 */
export const GetPendingActionsByTaskIDsResponse = new GetPendingActionsByTaskIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PendingActionState$Type extends MessageType<PendingActionState> {
    constructor() {
        super("c1.api.accessreview.v1.PendingActionState", [
            { no: 1, name: "unlocked", kind: "message", oneof: "state", T: () => PendingActionView },
            { no: 2, name: "locked", kind: "message", oneof: "state", T: () => LockedActionInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.PendingActionState
 */
export const PendingActionState = new PendingActionState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LockedActionInfo$Type extends MessageType<LockedActionInfo> {
    constructor() {
        super("c1.api.accessreview.v1.LockedActionInfo", [
            { no: 1, name: "submission_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "decision", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewPendingDecision", ReviewPendingDecision, "REVIEW_PENDING_DECISION_"] },
            { no: 3, name: "queued_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.LockedActionInfo
 */
export const LockedActionInfo = new LockedActionInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidatePendingActionsRequest$Type extends MessageType<ValidatePendingActionsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.ValidatePendingActionsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "certify_task_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { maxItems: "512", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ValidatePendingActionsRequest
 */
export const ValidatePendingActionsRequest = new ValidatePendingActionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ValidatePendingActionsResponse$Type extends MessageType<ValidatePendingActionsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.ValidatePendingActionsResponse", [
            { no: 1, name: "conflicts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PendingActionConflict },
            { no: 2, name: "valid_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "conflict_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ValidatePendingActionsResponse
 */
export const ValidatePendingActionsResponse = new ValidatePendingActionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DiscardAllPendingRequest$Type extends MessageType<DiscardAllPendingRequest> {
    constructor() {
        super("c1.api.accessreview.v1.DiscardAllPendingRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.DiscardAllPendingRequest
 */
export const DiscardAllPendingRequest = new DiscardAllPendingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DiscardAllPendingResponse$Type extends MessageType<DiscardAllPendingResponse> {
    constructor() {
        super("c1.api.accessreview.v1.DiscardAllPendingResponse", [
            { no: 1, name: "discarded_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.DiscardAllPendingResponse
 */
export const DiscardAllPendingResponse = new DiscardAllPendingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DiscardPendingBySearchRequest$Type extends MessageType<DiscardPendingBySearchRequest> {
    constructor() {
        super("c1.api.accessreview.v1.DiscardPendingBySearchRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "search_request", kind: "message", T: () => TaskSearchRequest, options: { "validate.rules": { message: { required: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.DiscardPendingBySearchRequest
 */
export const DiscardPendingBySearchRequest = new DiscardPendingBySearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DiscardPendingBySearchResponse$Type extends MessageType<DiscardPendingBySearchResponse> {
    constructor() {
        super("c1.api.accessreview.v1.DiscardPendingBySearchResponse", [
            { no: 1, name: "discarded_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "summary", kind: "message", T: () => PendingSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.DiscardPendingBySearchResponse
 */
export const DiscardPendingBySearchResponse = new DiscardPendingBySearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmitReviewRequest$Type extends MessageType<SubmitReviewRequest> {
    constructor() {
        super("c1.api.accessreview.v1.SubmitReviewRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "step_up_transaction_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "acknowledge_conflicts", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SubmitReviewRequest
 */
export const SubmitReviewRequest = new SubmitReviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmitReviewResponse$Type extends MessageType<SubmitReviewResponse> {
    constructor() {
        super("c1.api.accessreview.v1.SubmitReviewResponse", [
            { no: 1, name: "submission_accepted", kind: "message", T: () => SubmissionAccepted }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SubmitReviewResponse
 */
export const SubmitReviewResponse = new SubmitReviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmissionAccepted$Type extends MessageType<SubmissionAccepted> {
    constructor() {
        super("c1.api.accessreview.v1.SubmissionAccepted", [
            { no: 1, name: "submission_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "submission", kind: "message", T: () => SubmissionView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SubmissionAccepted
 */
export const SubmissionAccepted = new SubmissionAccepted$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSubmissionStatusRequest$Type extends MessageType<GetSubmissionStatusRequest> {
    constructor() {
        super("c1.api.accessreview.v1.GetSubmissionStatusRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "submission_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetSubmissionStatusRequest
 */
export const GetSubmissionStatusRequest = new GetSubmissionStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSubmissionStatusResponse$Type extends MessageType<GetSubmissionStatusResponse> {
    constructor() {
        super("c1.api.accessreview.v1.GetSubmissionStatusResponse", [
            { no: 1, name: "submission", kind: "message", T: () => SubmissionView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetSubmissionStatusResponse
 */
export const GetSubmissionStatusResponse = new GetSubmissionStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSubmissionsRequest$Type extends MessageType<ListSubmissionsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.ListSubmissionsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "state_filter", kind: "enum", T: () => ["c1.api.accessreview.v1.ReviewSubmissionState", ReviewSubmissionState, "REVIEW_SUBMISSION_STATE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ListSubmissionsRequest
 */
export const ListSubmissionsRequest = new ListSubmissionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListSubmissionsResponse$Type extends MessageType<ListSubmissionsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.ListSubmissionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SubmissionView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.ListSubmissionsResponse
 */
export const ListSubmissionsResponse = new ListSubmissionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InitiateStepUpForSubmitRequest$Type extends MessageType<InitiateStepUpForSubmitRequest> {
    constructor() {
        super("c1.api.accessreview.v1.InitiateStepUpForSubmitRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "return_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "certify_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.InitiateStepUpForSubmitRequest
 */
export const InitiateStepUpForSubmitRequest = new InitiateStepUpForSubmitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InitiateStepUpForSubmitResponse$Type extends MessageType<InitiateStepUpForSubmitResponse> {
    constructor() {
        super("c1.api.accessreview.v1.InitiateStepUpForSubmitResponse", [
            { no: 1, name: "submission_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "authorization_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.InitiateStepUpForSubmitResponse
 */
export const InitiateStepUpForSubmitResponse = new InitiateStepUpForSubmitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLatestSubmissionRequest$Type extends MessageType<GetLatestSubmissionRequest> {
    constructor() {
        super("c1.api.accessreview.v1.GetLatestSubmissionRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetLatestSubmissionRequest
 */
export const GetLatestSubmissionRequest = new GetLatestSubmissionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLatestSubmissionResponse$Type extends MessageType<GetLatestSubmissionResponse> {
    constructor() {
        super("c1.api.accessreview.v1.GetLatestSubmissionResponse", [
            { no: 1, name: "signature", kind: "message", T: () => SignatureView },
            { no: 2, name: "submission", kind: "message", T: () => SubmissionView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.GetLatestSubmissionResponse
 */
export const GetLatestSubmissionResponse = new GetLatestSubmissionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSubmissionsRequest$Type extends MessageType<SearchSubmissionsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.SearchSubmissionsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchSubmissionsRequest
 */
export const SearchSubmissionsRequest = new SearchSubmissionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSubmissionsResponse$Type extends MessageType<SearchSubmissionsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.SearchSubmissionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SubmissionView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchSubmissionsResponse
 */
export const SearchSubmissionsResponse = new SearchSubmissionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSubmissionsByAdminRequest$Type extends MessageType<SearchSubmissionsByAdminRequest> {
    constructor() {
        super("c1.api.accessreview.v1.SearchSubmissionsByAdminRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchSubmissionsByAdminRequest
 */
export const SearchSubmissionsByAdminRequest = new SearchSubmissionsByAdminRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchSubmissionsByAdminResponse$Type extends MessageType<SearchSubmissionsByAdminResponse> {
    constructor() {
        super("c1.api.accessreview.v1.SearchSubmissionsByAdminResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SubmissionView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SearchSubmissionsByAdminResponse
 */
export const SearchSubmissionsByAdminResponse = new SearchSubmissionsByAdminResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubmissionsDownloadRequest$Type extends MessageType<SubmissionsDownloadRequest> {
    constructor() {
        super("c1.api.accessreview.v1.SubmissionsDownloadRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SubmissionsDownloadRequest
 */
export const SubmissionsDownloadRequest = new SubmissionsDownloadRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewPendingActionsService
 */
export const AccessReviewPendingActionsService = new ServiceType("c1.api.accessreview.v1.AccessReviewPendingActionsService", [
    { name: "UpsertPendingAction", options: { "authz.method": { role: "EDITOR" } }, I: UpsertPendingActionRequest, O: UpsertPendingActionResponse },
    { name: "RemovePendingAction", options: { "authz.method": { role: "EDITOR" } }, I: RemovePendingActionRequest, O: RemovePendingActionResponse },
    { name: "ListPendingActions", options: { "authz.method": { role: "EDITOR" } }, I: ListPendingActionsRequest, O: ListPendingActionsResponse },
    { name: "GetPendingSummary", options: { "authz.method": { role: "EDITOR" } }, I: GetPendingSummaryRequest, O: GetPendingSummaryResponse },
    { name: "GetPendingActionsByTaskIDs", options: { "authz.method": { role: "EDITOR" } }, I: GetPendingActionsByTaskIDsRequest, O: GetPendingActionsByTaskIDsResponse },
    { name: "ValidatePendingActions", options: { "authz.method": { role: "EDITOR" } }, I: ValidatePendingActionsRequest, O: ValidatePendingActionsResponse },
    { name: "DiscardAllPending", options: { "authz.method": { role: "EDITOR" } }, I: DiscardAllPendingRequest, O: DiscardAllPendingResponse },
    { name: "DiscardPendingBySearch", options: { "authz.method": { role: "EDITOR" } }, I: DiscardPendingBySearchRequest, O: DiscardPendingBySearchResponse },
    { name: "SubmitReview", options: { "authz.method": { role: "EDITOR" } }, I: SubmitReviewRequest, O: SubmitReviewResponse },
    { name: "GetSubmissionStatus", options: { "authz.method": { role: "EDITOR" } }, I: GetSubmissionStatusRequest, O: GetSubmissionStatusResponse },
    { name: "ListSubmissions", options: { "authz.method": { role: "EDITOR" } }, I: ListSubmissionsRequest, O: ListSubmissionsResponse },
    { name: "InitiateStepUpForSubmit", options: { "authz.method": { role: "EDITOR" } }, I: InitiateStepUpForSubmitRequest, O: InitiateStepUpForSubmitResponse },
    { name: "GetLatestSubmission", options: { "authz.method": { role: "EDITOR" } }, I: GetLatestSubmissionRequest, O: GetLatestSubmissionResponse },
    { name: "SearchSubmissions", options: { "authz.method": { role: "EDITOR" } }, I: SearchSubmissionsRequest, O: SearchSubmissionsResponse },
    { name: "SearchSubmissionsByAdmin", options: { "authz.method": { role: "VIEWER" } }, I: SearchSubmissionsByAdminRequest, O: SearchSubmissionsByAdminResponse }
]);
